import { render, staticRenderFns } from "./PollsUsers.vue?vue&type=template&id=1f8afad0"
import script from "./PollsUsers.vue?vue&type=script&lang=js"
export * from "./PollsUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports